var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StreamBarcodeReader',{on:{"decode":_vm.onDecode,"loaded":_vm.onLoaded}}),(_vm.qrReaderResult)?_c('span',[_vm._v("Result Value: "+_vm._s(_vm.qrReaderResult))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }